import { Injectable } from '@angular/core'
import { ToastrService } from 'ngx-toastr'

interface ApiError {
    errorCode?: string
    message: string
    field?: string
}

export interface ApiErrorResponse {
    _body: string
}

@Injectable({
    providedIn: 'root',
})
export class ErrorListArrayMessageParser {
    constructor(private toastr: ToastrService) {}

    showErrorListMessage(errorList: ApiError[]) {
        this.toastr.error(this.getErrorString(errorList))
    }

    showErrorListMessageOrDefault(errorList: ApiError[], defaultMessage: string) {
        if (errorList && errorList.length > 0) {
            this.toastr.error(this.getErrorString(errorList))
        } else {
            this.toastr.error(defaultMessage)
        }
    }

    getErrorString(errorList: ApiError[]) {
        if (!errorList) {
            return 'Falha não mapeada'
        }

        return errorList.reduce((error, next) => {
            if (!next.message) {
                return ''
            }

            const errorCodeString = next.errorCode ? `${next.errorCode} - ` : ''
            if (errorList.length === 1) return error + `${errorCodeString}${next.message}`
            else return error + `${errorCodeString}${next.message}  /  `
        }, '')
    }
}
